<template>
  <div>
    <app-heading
      v-if="showHeading"
      :text="'Result'"
      :heading="'main'"
    ></app-heading>

    <v-row v-if="hasMultipleLocId || isOriginal">
      <v-col
        cols="12"
        v-if="
          $route.path === '/' &&
          sqResult.correlationId === undefined &&
          !showLocIdInput
        "
        class="pb-0"
      >
        <p class="red--text mb-0">
          *SQ result is required. Select location ID then click Run NBN SQ.
        </p>
      </v-col>
      <v-col
        cols="12"
        :sm="$route.path === '/' ? '9' : '10'"
        :class="$vuetify.breakpoint.xs ? 'pb-0 mb-0' : ''"
      >
        <ValidationProvider
          v-slot="{ errors }"
          name="Location ID"
          rules="required|alpha_num|loc_id_length:15|locationId"
        >
          <v-text-field
            v-if="showLocIdInput"
            label="Location ID"
            v-model="locId"
            @change="updateLocId"
            outlined
            :error-messages="errors"
            :clearable="!isOriginal"
            autocomplete="off"
            maxlength="15"
            @update:error="disableSqButton"
            :readonly="isOriginal"
            @click:clear="clearLocId()"
          ></v-text-field>
          <v-autocomplete
            v-else
            outlined
            :items="sortedQueryAddress"
            label="Select Location ID"
            v-model="locId"
            :item-text="locationText"
            item-value="locationId"
            :error-messages="errors"
            :clearable="!isOriginal"
            @change="updateLocationId"
            :readonly="isOriginal"
          >
          </v-autocomplete>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        :sm="$route.path === '/' ? '3' : '2'"
        :class="$vuetify.breakpoint.xs ? 'pt-0 mb-4' : ''"
      >
        <v-btn
          class="primary"
          :class="$vuetify.breakpoint.xs ? 'mt-0' : 'mt-2'"
          width="100%"
          large
          :disabled="!locId || disableButton || isOriginal"
          @click="runSQ()"
          >Run SQ</v-btn
        >
      </v-col>
    </v-row>
    <div style="overflow-x: auto">
      <div
        class="custom-div mt-5"
        :class="isServiceable ? 'serviceable' : 'not-serviceable'"
        v-if="(result.serviceability && result.parameters) || isOriginal"
      >
        <v-btn @click="copyText" class="primary mb-5" :disabled="isOriginal"
          >Copy Result</v-btn
        >
        <div ref="result">
          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              Address:
            </p>
            <p class="custom-p"><span v-html="tier1"></span>{{ newAddress }}</p>
          </div>

          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              NBN Co Location ID:
            </p>
            <p class="custom-p"><span v-html="tier1"></span>{{ locationID }}</p>
          </div>

          <div
            v-for="item in sqResult.parameters.parameter.filter(
              (x) => x.name === 'ServiceabilityClass'
            )"
            :key="item.name"
          >
            <div
              class="text-right py-0 pr-0 mr-3 font-weight-bold"
              :class="addClass"
              style="display: inline-block"
            >
              Service Class:
            </div>
            <div
              class="pl-0 py-0 font-weight-bold"
              style="display: inline-block"
              :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
            >
              <span v-html="tier1"></span>{{ setValue(item) }}
            </div>
            <span v-html="tier1"></span>
          </div>

          <div
            v-for="item in sqResult.parameters.parameter.filter(
              (x) => x.name === 'PrimaryAccessTechnology'
            )"
            :key="item.name"
            class="mb-6"
          >
            <div
              class="text-right py-0 pr-0 mr-3 font-weight-bold"
              :class="addClass"
              style="display: inline-block"
            >
              Primary Access Technology:
            </div>
            <div
              class="pl-0 py-0 font-weight-bold"
              style="display: inline-block"
              :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
            >
              <span v-html="tier1"></span>{{ item.value }}
            </div>
          </div>

          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              Address Latitude &amp; Longitude:
            </p>
            <p class="custom-p">
              <span v-html="tier1"></span>{{ formattedSQResult.latitude }},
              {{ formattedSQResult.longitude }}
            </p>
          </div>

          <div>
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              Region:
            </p>
            <p class="custom-p">
              <span v-html="tier1"></span>{{ formattedSQResult.region }}
            </p>
          </div>

          <div
            v-for="(item, index) in sqResult.parameters.parameter
              .filter(
                (x) =>
                  x.name !== 'ServiceabilityClass' &&
                  x.name !== 'PrimaryAccessTechnology' &&
                  !x.name.includes('NFAS TC2')
              )
              .filter((x) => x.name !== 'PrimaryAccessTechnolog')
              .filter((x) => !x.name.includes('TC2'))"
            :key="item.name + index"
          >
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              {{ `${item.name}:` }}
            </p>
            <p class="custom-p"><span v-html="tier1"></span>{{ item.value }}</p>
          </div>

          <div v-for="(item, index) in nfas" :key="item.name + index">
            <p class="custom-p text-right font-weight-bold" :class="addClass">
              {{ `${item.name}:` }}
            </p>
            <p class="custom-p"><span v-html="tier1"></span>{{ item.value }}</p>
          </div>

          <div
            v-for="(item, index) in sqResult.parameters.parameterGroup"
            :key="index"
            class="mt-4 pt-4 row-border"
          >
            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                {{ hasNtd ? "NTD ID:" : "Copper Pair ID:" }}
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ item.groupName }}
              </p>
            </div>

            <div v-if="showSection(item, 'UNI-D')" style="margin: 10px 0">
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
              >
                Data, UNI-D:
              </div>
              <div class="pl-0 py-0" style="display: inline-block">
                <div
                  v-for="(subItem, index) in item.parameter.filter((x) =>
                    x.name.includes('UNI-D')
                  )"
                  :key="index"
                >
                  <span v-html="tier1"></span>
                  <p style="width: 160px; display: inline-block" class="mb-0">
                    {{ subItem.port }}
                  </p>
                  <span v-html="tier2"></span>{{ subItem.status }}
                </div>
              </div>
            </div>

            <div v-if="showSection(item, 'UNI-V')" style="margin: 10px 0">
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
              >
                Voice, UNI-V:
              </div>
              <div class="pl-0 py-0" style="display: inline-block">
                <div
                  v-for="(subItem, index) in item.parameter.filter((x) =>
                    x.name.includes('UNI-V')
                  )"
                  :key="index"
                >
                  <span v-html="tier1"></span>
                  <p style="width: 160px; display: inline-block" class="mb-0">
                    {{ subItem.port }}
                  </p>
                  <span v-html="tier2"></span>{{ subItem.status }}
                </div>
              </div>
            </div>

            <div
              v-for="(subItem, index) in item.parameter.filter(
                (x) =>
                  !x.name.includes('UNI') &&
                  !x.name.includes('NTD') &&
                  !x.name.includes('PowerUnit') &&
                  !x.name.includes('TC2')
              )"
              :key="index"
            >
              <div
                div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
              >
                {{ `${subItem.name}:` }}
              </div>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ subItem.value }}
              </p>
            </div>

            <div
              v-if="showDetails(item, ['NTD', 'Power'])"
              style="margin: 10px 0"
            >
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
              >
                NTD Details:
              </div>
              <div class="pl-0 py-0" style="display: inline-block">
                <div v-for="(item, index) in ntdDetails" :key="index">
                  <span v-html="tier1"></span>
                  <p style="width: 160px; display: inline-block" class="mb-0">
                    {{ item.name }}
                  </p>
                  <span v-html="tier2"></span>{{ item.value }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-row v-if="showButtons">
      <v-col cols="12">
        <!-- <v-btn
          v-if="
            (result.serviceability === 'Serviceable - Shortfall' || result.serviceability === 'Serviceable') &&
            !hideOtherButtons
          "
          @click="createOrder()"
          class="primary"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mb-4' : ''"
          >Create Order</v-btn
        > -->
        <v-btn
          v-if="
            result.serviceability === 'Serviceable - Shortfall' &&
            !hideOtherButtons
          "
          @click="createEmail()"
          class="primary"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mb-4' : ''"
          :disabled="isOriginal"
          >Notify Customer</v-btn
        >
        <v-btn
          @click="cancel()"
          v-if="$route.path === '/'"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? '' : 'float-right'"
          :disabled="isOriginal"
          >Close</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "QualificationResult",
  props: {
    showHeading: { type: Boolean },
    showLocIdInput: { type: Boolean },
    showButtons: { type: Boolean },
    queryAddress: { type: Array },
    hasMultipleLocId: { type: Boolean },
    hideOtherButtons: { type: Boolean },
  },
  data: () => ({
    disableButton: false,
    result: {},
    locId: "",
    newResult: null,
    tier1: "&nbsp;",
    tier2: "&nbsp;&nbsp;&nbsp;",
    tier3: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    tier4: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    sorting: -1,
    primaryAccessTechnology: "",
    serviceClass: [
      {
        class: "0",
        description:
          "Planned to be serviced by Fibre in the future (boundary status isn't 'In Service' yet)",
      },
      {
        class: "1",
        description: "Serviceable by Fibre, no drop or NTD in place",
      },
      {
        class: "2",
        description: "Serviceable by Fibre, drop in place, no NTD in place",
      },
      {
        class: "3",
        description: "Serviceable by Fibre, drop and NTD in place",
      },
      {
        class: "4",
        description: "Planned to be serviced by Wireless",
      },
      {
        class: "5",
        description: "Serviceable by Wireless, CPE not installed",
      },
      {
        class: "6",
        description: "Serviceable by Wireless, CPE installed",
      },
      {
        class: "7",
        description: "Planned to be serviced by Satellite",
      },
      {
        class: "8",
        description: "Serviceable by Satellite, Satellite - NTD not installed",
      },
      {
        class: "9",
        description: "Serviceable by Satellite, Satellite - NTD installed",
      },
      {
        class: "10",
        description: "Planned to be serviceable by Copper",
      },
      {
        class: "11",
        description: "Serviceable by copper, active node present",
      },
      {
        class: "12",
        description: "Serviceable by copper, jumpering is required",
      },
      {
        class: "13",
        description: "Serviceable by copper, infrastructure in place",
      },
      {
        class: "20",
        description:
          "Planned to be serviced by HFC, outside plant does not exist",
      },
      {
        class: "21",
        description:
          "Serviceable by HFC, the location has a street TAP but requires a lead-in, PCD, internal tie cable, and wall-plate/socket",
      },
      {
        class: "22",
        description:
          "Serviceable by HFC, the location has a street TAP, lead-in & PCD in place, but no internal tie-cables with wall plates/sockets",
      },
      {
        class: "23",
        description:
          "Serviceable by HFC, the location has a wall-plate/socket but no HFC NTD",
      },
      {
        class: "24",
        description:
          "Serviceable by HFC, Location has a wall-plate/socket & HFC NTD and is 'Ready to Connect'",
      },
      {
        class: "30",
        description: "Planned to be serviceable by FTTC",
      },
      {
        class: "31",
        description: "Serviceable by FTTC, no line available (RPU required)",
      },
      {
        class: "32",
        description: "Serviceable by FTTC, cut-in required (RPU required)",
      },
      {
        class: "33",
        description: "Serviceable by FTTC, cut-in complete (RPU required)",
      },
      {
        class: "34",
        description:
          "Serviceable by FTTC, infrastructure in place (Check RPU status)",
      },
    ],
  }),
  methods: {
    clearLocId() {
      let vm = this;
      vm.setLocationID("");
      vm.setSqResult({});
      vm.resetFormattedSQResult();
    },
    displayOrder(item, sqResponse) {
      let vm = this;
      vm.locId = item.locationId;
      vm.$nextTick(() => {
        vm.result = sqResponse;
      });
    },
    locationText(val) {
      if (val.addressSiteName) {
        return `${val.formattedAddress} (${val.addressSiteName} - ${val.locationId})`;
      } else {
        return `${val.formattedAddress} (${val.locationId})`;
      }
    },
    createOrder() {
      let vm = this;
      let streetNrFirst = "",
        streetNrLast = "",
        streetName = "",
        streetType = "",
        suburb = "",
        postcode = "",
        stateOrProvince = "",
        longitude = "",
        latitude = "",
        formattedAddress = "",
        lotNumber = "";

      vm.result.address.additionalParameters.forEach((x) => {
        switch (x.name) {
          case "streetNrFirst":
            streetNrFirst = x.value;
            break;
          case "streetNrLast":
            streetNrLast = x.value;
            break;
          case "streetName":
            streetName = x.value;
            break;
          case "streetType":
            streetType = x.value;
            break;
          case "suburb":
            suburb = x.value;
            break;
          case "postcode":
            postcode = x.value;
            break;
          case "stateOrProvince":
            stateOrProvince = x.value;
            break;
          case "longitude":
            longitude = x.value;
            break;
          case "latitude":
            latitude = x.value;
            break;
          case "formattedAddress":
            formattedAddress = x.value;
            break;
          case "lotNumber":
            lotNumber = x.value;
            break;
        }
      });

      let address = {
        streetNrFirst: streetNrFirst,
        streetNrLast: streetNrLast,
        streetName: streetName,
        streetType: streetType,
        suburb: suburb,
        postcode: postcode,
        stateOrProvince: stateOrProvince,
        longitude: longitude,
        latitude: latitude,
        locationId: vm.locationId,
        formattedAddress: formattedAddress,
        lotNumber: lotNumber,
      };

      vm.$emit("createOrder", {
        withData: true,
        address: address,
        sqResult: vm.result,
        locationId: vm.locationID,
      });
    },

    updateLocationId() {
      let vm = this;
      vm.setLocationID(vm.locId);
      vm.resetData();
    },
    resetData() {
      let vm = this;
      vm.result = {};
      vm.setLocationID(vm.locId);
      vm.$emit("hideBaseOffer");
      vm.resetProduct();
    },

    createEmail() {
      let vm = this;
      vm.createTemplatedEmail().then(() => {
        //
      });
    },
    runSQ() {
      let vm = this;

      vm.resetHasNtd();

      let payload = {
        serviceType: "NBN",
        LocationId: vm.locId,
      };
      vm.serviceQualification(payload).then((data) => {
        vm.$emit("serviceability", data.data.serviceability);
        vm.result = data.data;
        vm.setFormattedSQResult(data.data);

        data.data.parameters.parameter.forEach((x) => {
          if (x.name === "PrimaryAccessTechnology")
            vm.primaryAccessTechnology = x.value;
        });

        vm.getExcludedProducts(vm.primaryAccessTechnology).then(() => {
          if (vm.isProductExcluded) {
            vm.setHttpResponse({
              text: vm.invalidProductErr,
              color: "error",
            });
          }
        });
      });
    },
    cancel() {
      let vm = this;
      vm.result = "";
      vm.setLocationID("");
      vm.setAddressQueryResult({});
      vm.$emit("cancel");
    },
    copyText() {
      let vm = this;
      vm.selectText(vm.$refs.result);
      document.execCommand("copy");
    },
    selectText(element) {
      var range;
      if (document.selection) {
        document.create;
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    setValue(item) {
      let vm = this;
      if (item.name === "ServiceabilityClass")
        return `${item.value} - ${
          vm.formattedSQResult.serviceability
        }. ${vm.setDescription(item)}.`;
      else return item.value;
    },
    setDescription(item) {
      let vm = this;
      let description = "";
      vm.serviceClass.forEach((x) => {
        if (x.class === item.value) description = x.description;
      });

      return description;
    },
    updateLocId() {
      let vm = this;
      vm.setLocationID(vm.locId);
    },
    showSection(data, type) {
      if (data.parameter.filter((x) => x.name.includes(type)).length > 0)
        return true;
      else return false;
    },
    showDetails(data, types) {
      let vm = this;
      let show = false;
      types.forEach((x) => {
        if (vm.showSection(data, x)) show = true;
      });
      return show;
    },
    disableSqButton(disable) {
      let vm = this;
      if (disable) vm.disableButton = true;
      else vm.disableButton = false;
    },
  },
  computed: {
    invalidProductErr() {
      let vm = this;
      return vm.$route.path === "/"
        ? `${vm.primaryAccessTechnology} is not included in our services. Can't proceed with the order.`
        : `${vm.primaryAccessTechnology} is not included in our services.`;
    },
    isServiceable() {
      let vm = this;
      if (vm.result.serviceability) {
        if (
          vm.result.serviceability.includes("Serviceable") &&
          !vm.result.serviceability.includes("Rejected") &&
          !vm.isProductExcluded
        )
          return true;
        else return false;
      } else return false;
    },
    sortedQueryAddress() {
      return this.queryAddress
        .slice(0)
        .sort((a, b) =>
          parseInt(a.lotNumber) < parseInt(b.lotNumber) ||
          parseInt(a.subUnitNr) < parseInt(b.subUnitNr) ||
          parseInt(a.streetNrFirst) < parseInt(b.streetNrFirst) ||
          parseInt(a.streetName) < parseInt(b.streetName)
            ? this.sorting
            : -this.sorting
        );
    },
    newAddress() {
      let vm = this;
      if (vm.sqResult.address) {
        let address = vm.sqResult.address.additionalParameters.filter(
          (x) => x.name === "formattedAddress"
        );
        return address[0].value;
      } else return "";
    },
    firstColumn() {
      let vm = this;
      if (vm.$route.path === "/") return "5";
      else return "4";
    },
    secondColumn() {
      let vm = this;
      if (vm.$route.path === "/") return "7";
      else return "8";
    },
    addClass() {
      let vm = this;
      if (vm.$route.path === "/") return "first-order";
      else return "first-sq";
    },
  },
  watch: {
    locationID: function () {
      let vm = this;
      vm.locId = vm.locationID;
    },
    locId: function () {
      let vm = this;
      vm.resetData();
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.serviceable {
  border-color: #2cd375 !important;
}

.not-serviceable {
  border-color: #ee3923 !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}
</style>